import React from 'react'
import { Table } from 'antd'
import FoundationWalletsTableColumns from './FoundationWalletsTableColumns'

interface Props {
  loading: boolean
  data: {
    address: string
    note: string
  }[]
  errorMessage: string | null
  tableSize: any
}

const FoundationWalletsTable: React.FC<Props> = ({ loading, data, errorMessage, tableSize }) => {
  return (
    <Table
      columns={FoundationWalletsTableColumns}
      rowKey={(record) => record.address}
      dataSource={data}
      size={tableSize}
      loading={loading}
      pagination={false}
    />
  )
}

export default FoundationWalletsTable
